/**
 * COMPANY INFO — single source of truth
 * --------------------------------------
 * Update these values when you have your real legal data (SRL/PFA).
 * Used by:
 *   - src/pages/Terms.tsx
 *   - src/pages/Privacy.tsx
 *   - src/components/AppFooter.tsx
 *   - src/lib/generateInvoicePdf.ts
 *   - supabase/functions/_shared/companyInfo.ts (KEEP IN SYNC — Deno cannot import from src/)
 *
 * After editing this file, ALSO update the matching values in
 * supabase/functions/_shared/companyInfo.ts so emails stay in sync.
 */

export const COMPANY_INFO = {
  /** Public brand name (no legal suffix). Never change unless rebranding. */
  brandName: "EZ Factura",

  /**
   * Legal entity name as registered.
   * TODO: replace with real value once SRL/PFA is set up.
   * Examples: "EZ Factura SRL"  ·  "PFA Popescu Ion"  ·  "Popescu Ion II"
   */
  legalName: "EZ Factura SRL",

  /** TODO: replace with full registered office address (street, no, city, county, postal code). */
  registeredAddress: "[ADRESĂ SEDIU SOCIAL]",

  /** TODO: replace with the fiscal code (CUI for SRL, CIF for PFA). Digits only or with "RO" prefix. */
  taxId: "[XXXXXXXX]",

  /** TODO: replace with Trade Registry number, e.g. "J40/1234/2026" or "F40/123/2026" for PFA. */
  registrationNumber: "J[XX/XXXX/XXXX]",

  /** Public contact email (also used as DPO contact for GDPR). */
  contactEmail: "contact@ezfactura.ro",

  /** Marketing site URL, no trailing slash. */
  websiteUrl: "https://ezfactura.ro",
  /** Domain only, used in copy. */
  websiteDomain: "ezfactura.ro",

  /** Year used in footer copyright. */
  copyrightYear: 2026,
} as const;

/** Legal entity is not yet finalized — true while placeholders are still in place. */
export const HAS_LEGAL_PLACEHOLDERS =
  COMPANY_INFO.registeredAddress.includes("[") ||
  COMPANY_INFO.taxId.includes("[") ||
  COMPANY_INFO.registrationNumber.includes("[");
